<template>
  <div class="my-5" :class="col ? `col-lg-${col}` : ''">
    <div class="single_image_input_wrapper">
      <span class="input_placeholder" v-if="placeholder">
        {{ placeholder }}
        <span class="text-danger" v-if="required"> * </span>
      </span>
      <div class="wrapper">
        <!-- Put previews and input inside the label so clicking anywhere opens the file picker -->
        <label :for="identifier" class="input_label">
          <img
            v-if="image.type == 'image_file'"
            :class="
              preSelectedImage || image.file
                ? 'image_uploaded'
                : 'image_placeholder'
            "
            :src="preSelectedImage ? preSelectedImage : image.path"
            alt="Image To Upload"
            width="100"
            height="100"
          />

          <video
            v-if="image.type == 'video_file'"
            autoplay
            controls
            loop
            muted
            class="w-100 h-100"
            ref="videoPreview"
          >
            <source :src="image.path" type="video/mp4" />
          </video>

          <div
            v-if="image.type == 'pdf_file'"
            class="pdf_preview d-flex align-items-center"
          >
            <img
              src="@/assets/media/images/upload_image.svg"
              alt="pdf"
              width="40"
              height="40"
            />
            <small class="ms-2 text-truncate" style="max-width: 160px">{{
              image.filename || image.file?.name || "PDF"
            }}</small>
          </div>

          <i class="fas fa-camera upload_icon" aria-hidden="true"></i>

          <input
            type="file"
            :accept="inputAccept"
            class="form-control"
            :id="identifier"
            @change="selectImageToUpload"
            :disabled="disabled"
            style="display: none"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import predictFileType from "@/utils/predictFileType.js";

export default {
  name: "BaseImageUploadInput",

  emits: ["selectImage"],

  props: {
    // ====== Start:: General Inputs Props ====== //
    col: {
      required: false,
      type: String,
    },
    identifier: {
      required: true,
      type: String,
    },
    preSelectedImage: {
      required: false,
      type: String,
    },
    placeholder: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    acceptVideo: {
      required: false,
      type: Boolean,
      default: false,
    },
    // ====== End:: General Inputs Props ====== //
  },

  data() {
    return {
      image: {
        path: require("@/assets/media/images/upload_image.svg"),
        file: null,
        type: "image_file",
        filename: null,
      },
      inputAccept:
        "image/png, image/jpg, image/jpeg, image/jfif ,video/*,application/pdf",
    };
  },

  watch: {
    preSelectedImage(newVal) {
      if (newVal) {
        const base = newVal.split("/").pop().split("?")[0];
        const fileType = predictFileType(base);
        this.image.type = fileType;
        this.image.path = newVal;
        this.image.filename = base;
      }
    },
  },

  methods: {
    checkExtension() {
      const fileType = this.image?.file?.type?.split("/")[0];
      console.log("🚀 ~ checkExtension ~ fileType:", fileType);
      return fileType;
    },
    // Start:: Select Image
    selectImageToUpload(e) {
      const selectedFile = e.target.files[0];
      if (!selectedFile) return;
      const fileType = predictFileType(selectedFile.name);

      // Allow images, videos (if acceptVideo true) and pdf files
      if (fileType === "image_file") {
        this.image.path = URL.createObjectURL(selectedFile);
        this.image.file = selectedFile;
        this.image.type = "image_file";
      } else if (fileType === "video_file") {
        if (!this.acceptVideo) {
          this.$message.error(this.$t("VALIDATION.selectedFileMustBeImage"));
          return;
        }
        this.image.path = URL.createObjectURL(selectedFile);
        this.image.file = selectedFile;
        this.image.type = "video_file";
      } else if (fileType === "pdf_file") {
        this.image.path = URL.createObjectURL(selectedFile);
        this.image.file = selectedFile;
        this.image.type = "pdf_file";
        this.image.filename = selectedFile.name;
      } else {
        // other types are not allowed
        this.$message.error(this.$t("VALIDATION.selectedFileMustBeImage"));
        return;
      }

      this.$emit("selectImage", {
        identifier: this.identifier,
        ...this.image,
      });

      if (this.image.type == "video_file") {
        this.$refs.videoPreview.load();
      }
    },
    // End:: Select Image
  },

  updated() {
    if (this.acceptVideo && !this.image.file) {
      this.inputAccept =
        "video/*,image/png, image/jpg, image/jpeg, image/jfif,application/pdf";
      this.image.path =
        this.preSelectedImage ??
        require("@/assets/media/images/upload_image.svg");
      if (this.preSelectedImage) {
        const base = this.preSelectedImage.split("/").pop().split("?")[0];
        this.image.type = predictFileType(base);
        this.image.filename = base;
      } else {
        this.image.type = "image_file";
        this.image.filename = null;
      }
    }
  },
  created() {
    if (this.preSelectedImage) {
      const base = this.preSelectedImage.split("/").pop().split("?")[0];
      const fileType = predictFileType(base);
      this.image.type = fileType;
      this.image.path = this.preSelectedImage;
      this.image.filename = base;
    } else {
      this.image.path = require("@/assets/media/images/upload_image.svg");
      this.image.filename = null;
    }
    if (this.acceptVideo == true) {
      this.inputAccept =
        "video/*,image/png, image/jpg, image/jpeg, image/jfif,application/pdf";
    } else {
      this.inputAccept =
        "image/png, image/jpg, image/jpeg, image/jfif,application/pdf";
    }
  },
};
</script>
